import { Grid } from "@material-ui/core";
import i18next from "../../../../assets/i18n/i18n";
import React from "react";
import "./login-portima-connect.scss";

export default class LoginPortimaConnect extends React.Component {
    render(): React.ReactElement {
        return (
            <Grid container spacing={3} justifyContent="flex-start" className="login-portima-connect-container">
                <Grid item xs={12} className="login-portima-connect-text">
                    {i18next.t("LoginPortimaConnect.UserNotConnected")}

                    <Grid item xs={12} className="login-portima-connect-text-bold">
                        <strong>{i18next.t("LoginPortimaConnect.ConnectFirstToCheckStatus")}</strong>
                    </Grid>
                    <Grid item xs={12} />
                </Grid>
            </Grid>
        );
    }
}
